import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            <div className="about-area py-120" style={{ marginTop: "-80px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row">
                                        <div className="col-6">
                                            <img className="img-1" src="assets/img/about/01.jpg" alt />
                                        </div>
                                        <div className="col-6">
                                            <img className="img-2" src="assets/img/about/02.jpg" alt />
                                        </div>
                                    </div>
                                </div>
                                <div className="about-experience">
                                    <h5>01<span>+</span></h5>
                                    <p>Years Of Experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-right wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="site-heading mb-3">
                                    <span className="site-title-tagline"><i className="far fa-solar-panel" /> About Us</span>
                                    <h2 className="site-title">We Are The Best &amp; Expert For <span>Your Solar</span> Solution</h2>
                                </div>
                                <p className="about-text"> Welcome to Yogesh Solar Energy, your trusted solar energy partner for over 1+ years of experience, we specialize in high-quality solar solutions for agriculture, commercial, industrial, residential, and rural areas.</p>
                                <p className="about-text"> Yogesh Solar Energy is committed to powering a sustainable future by delivering reliable, efficient, and eco-friendly solar energy solutions. With a strong focus on quality and customer satisfaction, we aim to make clean energy accessible and affordable for homes, businesses, and industries.</p>
                                <div className="about-content">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="about-item">
                                                <div className="icon">
                                                    <img src="assets/img/icon/install.svg" alt />
                                                </div>
                                                <div className="content">
                                                    <h6>Trust & Warrenty</h6>
                                                    <h6>24*7 Support</h6>
                                                    {/* <p>Choose Yogesh Solar Energy for trust and warranty.</p> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="about-item">
                                                <div className="icon">
                                                    <img src="assets/img/icon/material.svg" alt />
                                                </div>
                                                <div className="content">
                                                    <h6>High Quality Work</h6>
                                                    <h6>Cost-effective solutions</h6>
                                                    {/* <p>We use premium materials, expert craftsmanship, and advanced technology to ensure durable.</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Link to="/about" className="theme-btn">Discover More<i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="feature-area fa-negative" style={{marginTop:"-100px"}}>
                <div className="container">
                    <div className="feature-wrap">
                        <div className="row g-4">
                            <div className="col-md-6 col-lg-6">
                                <div className="feature-item">
                                    <span className="count">01</span>
                                    <div className="feature-icon">
                                        <img src="assets/img/icon/staff.svg" alt />
                                    </div>
                                    <div className="feature-content">
                                        <h4> Our Mission</h4>
                                        <p>To empower every home and business with sustainable solar energy and contribute to a cleaner environment.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-6">
                                <div className="feature-item">
                                    <span className="count">02</span>
                                    <div className="feature-icon">
                                        <img src="assets/img/icon/support.svg" alt />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Our Vision</h4>
                                        <p>To become a trusted leader in the solar energy industry by delivering innovative and efficient renewable energy solutions.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            




        </>
    )
}

export default HomeAbout